import { useMemo } from 'react';
import { useRouter } from 'next/router';

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

import { stages } from 'components/bookings/constants';

const defaultOption = {
  text: '-',
  value: '',
};

export const useUserBookingsFilterConfig = () => {
  const router = useRouter();

  const filterCategories = useMemo(
    () => [
      {
        id: 'stage',
        label: 'Stage',
        icon: RadioButtonUncheckedIcon,
        options: [defaultOption, ...stages],
        multiSelect: false,
      },
    ],
    []
  );

  const currentFilters = useMemo(() => {
    const parseQueryValue = (value, delimiter = ',') => {
      if (!value) return [];
      if (typeof value === 'string') {
        return value.split(delimiter).filter(Boolean);
      }
      return Array.isArray(value) ? value : [];
    };

    return {
      stage: parseQueryValue(router.query.stage),
    };
  }, [router.query]);

  return {
    filterCategories,
    currentFilters,
  };
};
